import React, { use } from "react";
import { Col, Form, Row } from "react-bootstrap";
import { useTranslation } from "react-i18next";

import { LotDetailContext } from "../../../../Contexts/LotDetailContext";
import { useNumberUtils } from "../../../../Utilities/useNumberUtils";

interface LotWeightRowProps {
    hasLotSize: boolean;
}

export function LotWeightFields({ hasLotSize }: LotWeightRowProps) {
    const { t } = useTranslation();
    const { formatLongNumber } = useNumberUtils();
    const {
        lotDetail: {
            summary: {
                lotWeight,
                loadoutWeight,
                weightUnit,
            }
        },
    } = use(LotDetailContext);

    return (
        <>
            {hasLotSize &&
                <Form.Group as={Col} sm={6} controlId="formSize">
                    <Row>
                        <Form.Label column sm={4}>{t('LotDetails.Summary.LotSize')}:</Form.Label>
                        <Col sm={8}>
                            <Form.Control type="text" disabled value={lotWeight ? formatLongNumber(lotWeight) + (weightUnit == null ? '' : " " + weightUnit) : ""} />
                        </Col>
                    </Row>
                </Form.Group>
            }
            <Form.Group as={Col} sm={6} controlId="formLoadoutWeight">
                <Row>
                    <Form.Label column sm={4}>{t('LotDetails.Summary.LoadoutWeight')}:</Form.Label>
                    <Col sm={8}>
                        <Form.Control type="text" disabled value={loadoutWeight ? formatLongNumber(loadoutWeight) + (weightUnit == null ? '' : " " + weightUnit) : ""} />
                    </Col>
                </Row>
            </Form.Group>

        </>
    );
}